/* 2nu interest signals v1. No commerce events, navigation changes or form data. */
(function (scope) {
  'use strict';
  const PIXEL = '547668275632054';
  const routes = {
    '/policies/shipping-policy': 'shipping',
    '/policies/refund-policy': 'returns',
    '/pages/lifetime-care-program': 'warranty'
  };
  const anchors = {'#care-shipping':'shipping','#care-returns':'returns','#care-lifetime':'warranty'};
  const phones = new Set(['85261414775','61492905299','85257225612']);
  function classify(href, base, label) {
    let u, origin;
    try { u = new URL(href, base); origin = new URL(base).origin; } catch (_) { return null; }
    if (u.username || u.password) return null;
    let phone = null;
    if (u.protocol === 'https:' && u.hostname === 'wa.me') phone = u.pathname.slice(1);
    if (u.protocol === 'https:' && ['api.whatsapp.com','web.whatsapp.com'].includes(u.hostname) && /^\/send\/?$/.test(u.pathname)) phone = u.searchParams.get('phone');
    if (u.protocol === 'whatsapp:' && u.hostname === 'send') phone = u.searchParams.get('phone');
    if (phone && phones.has(phone.replace(/[+()\s-]/g,''))) return {event:'WhatsAppClick',topic:'whatsapp'};
    if (!['http:','https:'].includes(u.protocol) || ![origin,'https://2nu.vision','https://2nu-prod.myshopify.com'].includes(u.origin)) return null;
    const path = u.pathname.replace(/^\/(?:en|zh)(?:-[a-z0-9]+)*(?=\/|$)/i,'').replace(/\/$/,'');
    const topic = routes[path] || (path === '/pages/support' && (anchors[u.hash] || (!u.hash && /^(return policy|退貨政策|退款政策)$/i.test(String(label || '').trim()) && 'returns')));
    return topic ? {event:'ConsiderationInteraction',topic} : null;
  }
  function allowed(privacy) {
    try { return !!privacy && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true; } catch (_) { return false; }
  }
  if (typeof module === 'object' && module.exports) module.exports = {classify,allowed};
  if (!scope.document || scope.twoNuInterestEventsV1) return;
  scope.twoNuInterestEventsV1 = true;
  const doc = scope.document, seen = new Set();
  if (!scope.Shopify?.customerPrivacy && typeof scope.Shopify?.loadFeatures === 'function') {
    scope.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function () {});
  }
  doc.addEventListener('click', function (event) {
    try {
      if (!event.isTrusted || (event.button !== undefined && event.button !== 0)) return;
      const link = event.target.closest?.('a[href]');
      if (!link || link.closest('[data-zo-ai-share],share-button,.share-button')) return;
      // Support coordinator rewrites chat launchers; these are not WhatsApp clicks.
      if (link.hasAttribute('data-two-nu-support-trigger')) return;
      const signal = classify(link.getAttribute('href'),doc.baseURI,link.textContent);
      if (!signal || !allowed(scope.Shopify?.customerPrivacy) || typeof scope.fbq !== 'function') return;
      const key = signal.event + ':' + signal.topic;
      if (seen.has(key)) return;
      scope.fbq('trackSingleCustom', PIXEL, signal.event, {interaction_type:signal.topic,signal_version:'1'});
      seen.add(key);
    } catch (_) { /* Tracking must never interrupt the shopper's action. */ }
  }, true);
})(typeof window === 'object' ? window : globalThis);
